<script lang="ts">
    import {onMount} from "svelte";
    import AuthStateView from "../auth/AuthStateView.svelte";
    import ImageView from "../common/Image/ImageView.svelte";


    onMount(() => {
    });


</script>
<div class="header-view">
    <div class="left-area">
        <div class="logo-area">
            <a href="/#/">
                <ImageView src="/img/logo.png"/>
            </a>
        </div>

        <div id="header-left-portal-target"></div>

    </div>

    <div class="right-area">
        <AuthStateView/>
    </div>


</div>
<style lang="scss">
    .header-view {
        background: var(--header-background);
        color: var(--header-text-color);
        height: var(--header-height);

        display: flex;
        align-items: center;

        .left-area {
            display: flex;
            align-items: center;
            flex-grow: 1;

            .logo-area {
                padding-left: 12px;
                padding-right: 12px;
                height: 100%;

                display: flex;
                align-items: center;
                justify-content: center;

                font-size: 24px;
                letter-spacing: 0.1em;

                > a {
                    width: 100%;
                    height: 40px;

                    position: relative;

                    :global(img) {


                        transition-duration: 0.25s;
                        transition-timing-function: linear;

                        width: 100%;
                        height: 40px;
                    }

                    .logo-front {
                        transform: rotateX(0deg);
                        transition-delay: 0.25s;

                    }

                    .logo-back {
                        position: absolute;
                        top: 4px;
                        left: 0;
                        transform: rotateX(90deg);
                    }
                }

                &:hover {
                    > a {
                        .logo-front {
                            transform: rotateX(90deg);
                            transition-delay: 0s;

                        }

                        .logo-back {
                            transform: rotateX(0deg);
                            transition-delay: 0.25s;

                        }
                    }
                }

            }


        }


        .right-area {


            padding-right: 12px;
            display: flex;
            align-items: center;

        }

    }
</style>